let TemporaryAccessToken:string;

export const setItem = async (key: string, value: any) => {
  try {
    await null;
    return localStorage.setItem(key, value);
  } catch (e) {
    // console.error(e);
  }
};

export const getItem = async (key: string) => {
  try {
    await null;
    return localStorage.getItem(key);
  } catch (e) {
    // console.error(e);
  }
  
};


// need to comment
export const getToken = () => {
  let access_token = null;
  // @ts-ignore
  // const tokens = JSON.parse(localStorage.getItem('tokens'));
  let isToken = localStorage.getItem('tokens' || '');
  if (isToken !== null) {
    let tokenData = JSON.parse(isToken);
    if (tokenData !== null && tokenData.access_token !== undefined) {
      access_token = tokenData.access_token;
    }
  }

  return access_token;
};

// export const setTemporaryAccessToken= (accessToken:string) =>{
//   TemporaryAccessToken = accessToken;
// }
// export const getTemporaryAccessToken = () => TemporaryAccessToken;
// need to comment